"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DayTypeModel {
    constructor(cache) {
        this.setDayTypes = (customerId, dayTypeMap) => this.cache.setObject(this.key(customerId), dayTypeMap).asPromise();
        this.getDayType = async (customerId, date) => {
            const dayTypes = await this.getDayTypes(customerId);
            return dayTypes[date] || null;
        };
        this.getDayTypes = async (customerId) => (await this.cache.getObject(this.key(customerId)).asPromise());
        this.key = (customerId) => `MOCK_DAY_TYPES.${customerId}`;
        this.cache = cache;
    }
}
exports.default = DayTypeModel;
//# sourceMappingURL=DayTypeModel.js.map